import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'

import { getJbpHpContactsCrud } from '../lib'

interface IParams {
  changeRequest: IFormJBPHPContactChangeRequest
}

export const updateChangeRequest = async ({ changeRequest }: IParams) => {
  const crud = getJbpHpContactsCrud('welcome-flow-add-request')

  changeRequest = {
    ...changeRequest,
    EntryId: changeRequest.TicketId,
    Status: changeRequest.TicketStatus,
    Action: changeRequest.RequestAction,
  }

  await crud.update({ formId: '1217', code: 'jbp-hp-contact-change-request-1217' }, [changeRequest])
}
